import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  CdsColorActionCriticalDarkActive,
  CdsColorActionInfoDarkActive,
  CdsColorActionSuccessDarkActive,
  CdsColorActionWarnDarkActive,
  CdsColorBackgroundCriticalLight,
  CdsColorBackgroundInfoLight,
  CdsColorBackgroundSuccessLight,
  CdsColorBackgroundWarnLight,
  CdsSizeRadius
} from '@cegid/design-tokens';

export const useStyles = makeStyles((theme: Theme) => ({
  info: {
    boxShadow: 'none',
    borderRadius: CdsSizeRadius,
    margin: '1em 0px 1em 0px',
    color: CdsColorActionInfoDarkActive,
    background: CdsColorBackgroundInfoLight
  },
  warning: {
    boxShadow: 'none',
    borderRadius: CdsSizeRadius,
    margin: '1em 0px 1em 0px',
    color: CdsColorActionWarnDarkActive,
    background: CdsColorBackgroundWarnLight
  },
  error: {
    boxShadow: 'none',
    borderRadius: CdsSizeRadius,
    margin: '1em 0px 1em 0px',
    color: CdsColorActionCriticalDarkActive,
    background: CdsColorBackgroundCriticalLight
  },
  success: {
    boxShadow: 'none',
    borderRadius: CdsSizeRadius,
    margin: '1em 0px 1em 0px',
    color: CdsColorActionSuccessDarkActive,
    background: CdsColorBackgroundSuccessLight
  }
}));
